export default __webpack_public_path__ + "static/media/ic-flag.10bbe91f.svg";